export default __webpack_public_path__ + "static/media/emptyItem.480ca9c8.svg";